import { BookingAnalyticsApi } from './bookingAnalyticsApi';
import { transformTraceLogsResponse } from './api';

/**
 * Fetch trace logs via the structured AND/OR filter-tree endpoint.
 * Endpoint: GET /api/admin/v1/booking-analytics/trace-logs (see requirements/API055, ioo-338)
 *
 * Response envelope is identical to the plain-listing path (`data.data`,
 * `data.meta`, `data.status_summary`, `data.modules`) so the existing
 * transform helpers apply unchanged.
 *
 * @param {number} page
 * @param {{ dateRange?: [dayjs, dayjs] | null, filters?: object | null, perPage?: number }} options
 */
export async function fetchTraceLogsAdvanced(page = 1, { dateRange, filters, perPage = 20 } = {}) {
  const params = { page, per_page: perPage };

  if (dateRange && dateRange[0] && dateRange[1]) {
    params.date_from = dateRange[0].format('YYYY-MM-DD');
    params.date_to = dateRange[1].format('YYYY-MM-DD');
  }
  if (filters) {
    params.filters = filters;
  }

  const response = await BookingAnalyticsApi.getLogsAdvanced(params);

  if (!response?.success) {
    throw new Error(response?.message || 'Failed to fetch analytics logs');
  }

  const envelope = response.data;
  const { logs, pagination } = transformTraceLogsResponse(envelope);

  return {
    logs,
    pagination,
    statsData: envelope?.status_summary || null,
    modules: envelope?.modules || [],
  };
}
